import React from 'react'
import PropTypes from 'prop-types'
import { withHoverProps } from '@klarna/higher-order-components'
import { constants, IconProfile } from 'mage-deps/@klarna/bubble-ui'
import * as R from 'ramda'
import DelayedTooltip from '../DelayedTooltip'
import { Message } from 'mage-i18n'
import { components as coreComponents } from 'mage-core'
import ResponsiveMenuButton from '../ResponsiveMenuButton'

function UserMenuIcon ({ isTooltipEnabled, givenName, familyName, hover, onMouseOver, onMouseOut, toggled }) {
  const styleSheet = {
    flexed: {
      display: 'flex',
      borderWidth: 1
    },
    cursor: {
      cursor: 'pointer'
    },
    toolTipContainerStyles: {
      position: 'absolute',
      right: 25,
      zIndex: constants.Layers.TOOLTIP,
      width: 120,
      top: 60
    }
  }

  const displayName = getDisplayName(givenName, familyName)
  return (
    <div onMouseOver={onMouseOver} onMouseOut={onMouseOut} style={styleSheet.flexed}>
      <ResponsiveMenuButton
        id='header-usermenu-icon'
        toggled={toggled}
        Icon={IconProfile}
        label={displayName}
        isBorderless
      />
      {hover && isTooltipEnabled && (
        <div style={styleSheet.toolTipContainerStyles}>
          <DelayedTooltip arrow='top'>
            <Message path='core.usermenu.tooltip' />
          </DelayedTooltip>
        </div>
      )}
    </div>
  )
}

const getDisplayName = (givenName, familyName) => {
  return (givenName && familyName)
    ? `${givenName} ${familyName.charAt(0)}.`
    : (givenName ? `${givenName}` : '?')
}

UserMenuIcon.propTypes = {
  isTooltipEnabled: PropTypes.bool,
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  hover: PropTypes.bool,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  toggled: PropTypes.bool
}

UserMenuIcon.defaultProps = {
  isTooltipEnabled: true
}

export default R.compose(
  withHoverProps({ hover: true }),
  coreComponents.withTokenHelper(tokenHelper => ({
    givenName: tokenHelper.getGivenName(),
    familyName: tokenHelper.getFamilyName()
  }))
)(UserMenuIcon)
